import React, { useEffect, useState } from "react";
import styles from "./Auth.module.css";
import InputField from "./InputField";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import aws_exports from "../../aws-exports";

Amplify.configure(aws_exports);

function ForgotPassword() {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        confirmationCode: ""
    });
    const [eye, setEye] = useState(false); // For visibility
    const [passwordResetStep, setPasswordResetStep] = useState(1);

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const source = queryParams.get('source');

    useEffect(() => {
        if(source === "registered") {
            toast.info("Account Created. Please, check your email for next steps.");
        }
    }, [source]);

    function handleInputChange(field, value) {
        setFormData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    function eyeClick() {
        setEye((prev) => !prev)
    }

    async function handleSubmit(e) {
        e.preventDefault();
    
        const { email, password, confirmationCode } = formData;
    
        if (!email) {
            toast.error("Please enter your email address.");
            return;
        }
    
        if (passwordResetStep === 1) {
            try {
                await resetPassword({ username: email });
    
                toast.info("Password reset email sent. Please check your email.");
                
                setPasswordResetStep(2);
            } catch (error) {
                console.error("Forgot password error: ", error);
                toast.error(error.message || "An error occurred during password reset.");
            }
    
            return;
        }
    
        if (!password) {
            toast.error("Please enter your password.");
            return;
        }
    
        try {
            await confirmResetPassword({ username: email, newPassword: password, confirmationCode });

            navigate("/auth/login");
        } catch (error) {
            console.error("Forgot password error: ", error);
            toast.error(error.message || "An error occurred during password reset.");
        }
    }    

    return (
        <div className={styles["login-content"]}>
            <ToastContainer
                position="top-center"
                autoClose={false}
                hideProgressBar={false}
                newestOnTop={true}
                closeButton={true}
            />
    
            <div className={styles["auth-form-header"]}>
                <h5>Reset Password</h5>
            </div>
    
            <form className={styles["register-form"]} onSubmit={handleSubmit}>
                <InputField 
                    desc="Email address*"
                    type="email"
                    name="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={(value) => handleInputChange("email", value)}
                />
    
                {passwordResetStep !== 1 && (
                    <>
                        <InputField 
                            desc="Confirmation Code*"
                            type="text"
                            name="confirmationCode"
                            placeholder="Enter your confirmation code"
                            value={formData.confirmationCode}
                            onChange={(value) => handleInputChange("confirmationCode", value)}
                        />

                        <div className={`${styles["input"]} ${styles["password-input"]}`}>
                            <p className={styles["input-desc"]}>New Password*</p>
        
                            <div className={styles["pwd"]}>
                                <input 
                                    type={eye ? "text" : "password"}
                                    className={styles["input-field"]}
                                    name="password"
                                    placeholder="Enter your new password"
                                    value={formData.password}
                                    onChange={(e) => handleInputChange("password", e.target.value)}
                                />
        
                                {eye ? (
                                    <VisibilityIcon 
                                        className={styles["viz-icon"]} 
                                        onClick={eyeClick}
                                    />
                                ) : (
                                    <VisibilityOffIcon 
                                        className={styles["viz-icon"]} 
                                        onClick={eyeClick}
                                    />
                                )}
                            </div>
                        </div>
                    </>
                )}
    
                <div className={styles["auth-form-footer"]}>    
                    <Button 
                        className={`${styles["btn-dark"]}`} 
                        type="submit"
                    >
                        Submit
                        <ArrowForwardIcon className={styles["btn-arrow"]}/>
                    </Button>
                </div>         
            </form>
        </div>
    );    
}

export default ForgotPassword;